<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide :isButton="isButton" @companyUpgrade ="onUpgrade"></companySide>
          <div class="mt-30">
            <!-- <div class="fsc head">
              <span>用户级别&nbsp;:</span><span>&nbsp;&nbsp;付费会员</span>
              <img class="ml-5" src="../../assets/images/grade.jpg" alt="" />
            </div> -->
            <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
            <div>
              <div class="table">
                <moreTable class="mt-30" v-if ="show == true"></moreTable>
                <div v-if="hide == true" class="info_form mt-30">
                  <el-form  ref="form" :rules="rules"  :model="form" label-width="120px">
                     <div class="form_box">
                       <p v-if="userType == 4 || userType == 5">法人身份证件(正面) :</p>
                       <p v-else>身份证件(正面)</p>
                       <div class="ml-10">
                          <el-upload
                          list-type="picture-card"
                          :limit="1"
                          :headers="{token:token}"
                          action="/api/zwb/app/oss/public/upload"
                          :on-success="onSuccess"
                          :before-upload="handlePreview"
                          >

                          <p>选择照片</p>
                          <el-dialog :visible.sync="dialogVisible">
                              <img width="100%" :src="dialogImageUrl" alt="">
                          </el-dialog>
                      </el-upload>
                       </div>
                     </div>
                     <div class="form_box mt-20">
                       <p v-if="userType == 4 || userType == 5">法人身份证件(反面) :</p>
                       <p v-else>身份证件(反面)</p>
                       <div class="ml-10">
                            <el-upload
                            list-type="picture-card"
                            :limit="1"
                            :headers="{token:token}"
                            action="/api/zwb/app/oss/public/upload"
                            :on-success="handleSuccess"
                            :before-upload="handlePreview"
                            >
                            <p>选择照片</p>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                          </el-upload>
                       </div>
                     </div>
                    <div class="tel">
                       <button @click.prevent="onpay('form')" class="upgrade">提交资料</button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import {card,createorder,getVip,upvip,orderinfo,agreement} from '@/api/coment'
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import moreTable from "../../components/moreTable";
export default {
  components: {
    sidebar,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    moreTable,
  },
  data() {
  //银行卡号
  // var cardNum = (rule, value, callback)=>{
  //  const regCardNum = /^([1-9]{1})(\d{15}|\d{19})$/
  //  if(regCardNum.test(value) ){
	//   return callback();
  //  }
  //  callback(new Error("请输入合法的银行卡号"));
  // };
    return {
      userType: 0,
      contTitle: "完善身份信息",
      headTitle: "企业介绍",
      obj: {
        title: "会员权益",
        isShow: false,
        roleType:3,
        personalType:9
      },
      show:false,
      hide:true,
      form:{
        realname:'', //姓名
        // id_back:'', //反面
        // id_front:'', //正面
        bank_name:'',//开户银行
        bank_code:'',//开户账号
      },
      rules:{
          realname: [{ required: true, message: '请输入公司法人姓名', trigger: 'blur' }],
          bank_name:[{ required: true, message: '请输入公司银行名称', trigger: 'blur' }],
          bank_code:[{ required: true, message: '请输入公司账号', trigger: 'blur' }]
      },
      dialogImageUrl: '',
      dialogVisible:false,
      disabled: false,
      token:getToken(),
      dialogFormVisible:false,
      retForm:{
        amount:'',
        goodsId:'',
        goodsType:1000,
        agree:''
      },
      rules:{
          agree: [{ required: true, message: "请接受智污邦缴费协议",trigger: "change"}]
      },
      payAgreemant:'',
      payTime:10,
      payImg:false,
      dialogPay:false,
      vipObj:{},
      isButton:false
    };
  },
  created(){
    this.userType = (JSON.parse(localStorage.getItem('data'))).data2.id
  },
  methods: {
     //会员升级
     onUpgrade(data){
      this.getUpvip(data);
     },
     handleRemove(file) {},
      //文件上传成功返回
      onSuccess(res){ //正面
        if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
         this.dialogImageUrl = res.url;
         this.form.id_front = res.url;
       }
      },
      handleSuccess(res){ //反面
        if (res.code == 0) {
        this.$message({
          message: "上传成功！",
          type: "success",
        });
         this.dialogImageUrl = res.url;
         this.form.id_back = res.url;
       }
      },
      handlePreview(file){
        //上传前对图片类型和大小进行判断
        const isJPG =
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg";
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isJPG) {
          this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
        }
        if (!isLt3M) {
          this.$message.error("上传头像图片大小不能超过 3MB!");
        }
        return isJPG && isLt3M;
      },
     //缴费
      onpay(formName){
        this.$refs[formName].validate((valid) => {
           if(valid){
             console.log("开始请求")
             card(this.form).then((res)=>{
               if(res.code ==0){
                 this.$alert('提交成功，等待审核！','信息提示',{
                   confirmButtonText: '确定',
                   callback: action => {
                     this.$router.push({path:'/income'})
                   }
                 })
               }
             }).catch((err)=>{})
           }else{
              return false
           }
        })
      },
     
     
      onChange(event){
        this.vipList.forEach((item)=>{
          if(item.cvalue == event){
            this.retForm.amount = event;
            this.retForm.goodsId = item.id;
          }
        })
      },
      
  
      PayChange(){
        this.dialogPay = true;
        this.timers = setInterval(() => {
          this.payTime--;
          if (this.payTime == 0) {
            clearInterval(this.timers);
            this.payImg = true;
          }
        }, 1000);
      },
      onText() {
      this.dialogPay = false;
    },
  },
};
</script>
<style scoped="scoped">
/* .el-aside{
    height: 930px;
} */
.head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 30px;
}
.fjs{
  display: flex;
  justify-content: flex-start;
}
.info_form h4{
   margin-top: 20px;
   font-size: 20px;
}
.info_form>>>.el-form-item{
   margin-top: 20px;
}
.info_form>>>.el-input__inner{
    width: 86%;
}

.info_form>>>.el-form-item__error{
   left: 38px;
}
.form_box{
   display: flex;
   justify-content: flex-start;
}
.form_box p{
  font-size: 14px;
  color: #606266;
  margin-left: 8px;
}
.remarks{
  text-align: left;
  margin-left: 30px;
  font-size: 14px;
  margin-top: 30px;
  line-height: 24px;
}
.upgrade{
  width: 108px;
  height: 39px;
  background: #3BBB35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  text-align:center;
  margin-left: 30px;
  margin-top: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-5 {
  margin-left: 5px;
}
.ml-10{
  margin-left: 10px;
}
.z-2050{
  z-index: 2050 !important;
}
.mert_dialog{
  height: 30px;
  line-height: 30px;
}
.mert_form{
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.mert_bater{
  margin-left: 30px;
  text-align: left;
}
.mert_bater p{
  font-size: 14px;
}
.mert_bater p:nth-child(1){
  width: 200px;
}
.mert_price{
  margin-left: 20px;
  /* color:rgb(255, 116, 2); */
  font-size: 16px;
}
.mert_price span:nth-child(2){
  color:rgb(255, 116, 2);
  font-size: 16px;
}
/deep/.dialog-footer{
  text-align:left;
  margin-left: 30px;
}
/deep/.el-button{
  width: 129px;
  height: 35px;
  /* border: none; */
}
/deep/.el-button--primary{
  background: #3BBB35;
  border:none;
}
.footer_buts:hover{
  background: #fff;
  color: #000;
  border-color: #ebebeb;
}
.el-form-item{
  margin-left: 30px;
}
.dialog_form >>>.el-dialog{
  width: 440px !important;
  height: 320px !important;
}

.dialog_form >>>.el-dialog__footer{
  margin-top: -41px ;
}



/**协议弹框 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}


.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
  margin-left: 0px !important;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
   text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_card.vue